import React from "react";
import { FlameIcon } from "lucide-react";
type ScarcityBarProps = {
  dark?: boolean;
  spotsText?: string;
};
export function ScarcityBar({
  dark = false,
  spotsText = "at the promotional price"
}: ScarcityBarProps) {
  return <div className={`mx-auto w-full max-w-md rounded-2xl p-4 ${dark ? "bg-white/10" : "border border-red-200 bg-white"}`} data-id="element-69" data-mp="2l4em89lzt6n1">
      <div className="flex items-center justify-between gap-3" data-id="element-70" data-mp="2q1wk94yh21g9">
        <span className={`text-xs font-extrabold uppercase tracking-wider ${dark ? "text-gold-light" : "text-red-700"}`} data-id="element-71" data-mp="2b5yuc4f55tch">
          Limited launch price
        </span>
        <span className={`text-xs font-extrabold ${dark ? "text-white" : "text-red-700"}`} data-id="element-72" data-mp="226lij53josol">91% CLAIMED</span>
      </div>
      <div className={`mt-2 h-4 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-red-100"}`} role="progressbar" aria-valuenow={91} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-73" data-mp="2766i9hqjh52d">
        <div className="h-full w-[91%] rounded-full bg-red-600" data-id="element-74" data-mp="33md1cwm4lkl5" />
      </div>
      <p className={`mt-2.5 flex items-center justify-center gap-1.5 text-center text-sm font-semibold ${dark ? "text-white" : "text-navy"}`} data-id="element-75" data-mp="2zl9o8hvgq2nm">
        <FlameIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-76" data-mp="3dbmvei0j5dbw" />
        <span data-id="element-77" data-mp="38dbl666bp0t5">
          Only <strong className="text-red-500" data-id="element-78" data-mp="38ewgvz4dipsl">9 spots</strong> remaining {spotsText}.
        </span>
      </p>
    </div>;
}